import { render, staticRenderFns } from "./IList.vue?vue&type=template&id=5119ed66&scoped=true&"
import script from "./IList.vue?vue&type=script&lang=ts&"
export * from "./IList.vue?vue&type=script&lang=ts&"
import style0 from "./IList.vue?vue&type=style&index=0&id=5119ed66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119ed66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VRow})
